module.exports = __webpack_public_path__ + "img/yt.c1a06ffa.svg";